export const HEALTH_CHECK = 'health-check'
export const MID_SHIFT = 'mid-shift-screening'
export const ENTRY = 'entry-screening'
export const EXIT = 'exit-screening'
export const EXIT_WITH_TEMP = 'exit-screening-ohio'
export const COVID_VACCINE_TRACKING = 'vaccine-tracking'
export const TEST_TRACKING = 'test-tracking'
export const IMMUNIZATION_TRACKING = 'immunization-tracking'
